import React, { useEffect, useState, useCallback } from "react";
import {
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Tabs,
  Tab,
  Box,
  Stack,
  Typography,
  Link,
} from "@mui/material";
import { useUser } from "../../contexts/userContext.jsx";
import { DOMAIN } from "../../config/index.js";

// 工具函数：POST 请求
const sendPostRequest = async (url, data) => {
  try {
    const res = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    if (!res.ok) throw new Error("网络响应不是 OK");
    return await res.json();
  } catch (err) {
    console.error("出错:", err);
    return null;
  }
};

// 工具函数：base64url 编码
const base64urlEncode = (str) =>
  btoa(str).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");

export const LoginTg = ({ activeTab, handleTabChange, onClose, tuser }) => {
  const [form, setForm] = useState({ username: "", password: "", confirmPassword: "" });
  const [errors, setErrors] = useState({});
  const [registed, setRegisted] = useState(true);
  const [userInfo, setUserInfo] = useState(null);
  const [vipInfo, setVipInfo] = useState(null);
  const { setUserData,userData } = useUser();
//测试
  console.log(userData)

  // 输入变化处理
  const handleChange = (field) => (e) => {
    setForm({ ...form, [field]: e.target.value });
    setErrors({ ...errors, [field]: "" });
  };

  // 获取用户 & VIP 信息
  useEffect(() => {
    const loadUserData = async () => {
      const [user, vip] = await Promise.all([
        fetch(`${DOMAIN}ywyminiappbot/getUser?userid=${tuser.user.id}`).then((res) => res.json()),
        fetch(`${DOMAIN}ywyminiappbot/isvip?userid=${tuser.user.id}`).then((res) => res.json()),
      ]);
      if (!user.username) {
        setRegisted(false);
        setUserInfo(user);
        setUserData(user)
      } else {
        setUserInfo(user);
        setUserData(user);
      }
      setVipInfo(vip);
    };
    loadUserData();
  }, [tuser.user.id, setUserData]);

  // 校验逻辑
  const validate = useCallback(
    (mode) => {
      const newErrors = {};
      const { username, password, confirmPassword } = form;

      if ((mode === "login" || mode === "register") && (username.length < 4 || username.length > 20)) {
        newErrors.username = "用户名需 4-20 位";
      }

      if ((mode === "login" || mode === "register" || mode === "changepass") && password.length < 6) {
        newErrors.password = "密码需至少 6 位";
      }

      if ((mode === "register" || mode === "changepass") && password !== confirmPassword) {
        newErrors.confirmPassword = "两次密码输入不一致";
      }

      setErrors(newErrors);
      return Object.keys(newErrors).length === 0;
    },
    [form]
  );

  // 登录
  const handleLogin = async () => {
    if (!validate("login")) return;
    const { username, password } = form;

    const login = await sendPostRequest(
      `${DOMAIN}ywyminiappbot/userlogin`,
      { username, password }
    );

    if (!login || login.length === 0) {
      setErrors({ username: "用户名或密码错误" });
      return;
    }

    const confirm = window.confirm(
      `将把用户 ${username} 的数据覆盖到此电报号，您确定要这样做吗？`
    );
    if (!confirm) return;

    window.Telegram.WebApp.ready();
    window.Telegram.WebApp.openTelegramLink(
      `https://t.me/ywydizhibot?start=type_cU-usr_${base64urlEncode(username)}-pas_${base64urlEncode(password)}`
    );
  };

  // 注册
  const handleRegister = () => {
    if (!validate("register")) return;
    const { username, password } = form;

    window.Telegram.WebApp.ready();
    window.Telegram.WebApp.openTelegramLink(
      `https://t.me/ywydizhibot?start=type_register-username_${username}-password_${password}`
    );
    onClose();
  };

  // 修改密码
  const handleChangePass = () => {
    if (!validate("changepass")) return;
    const { password } = form;

    window.Telegram.WebApp.ready();
    window.Telegram.WebApp.openTelegramLink(
      `https://t.me/ywydizhibot?start=type_changepass-password_${password}`
    );
    onClose();
  };

  // ---- UI 渲染 ----
  return (
    <Box sx={{ bgcolor: "#fafafa", borderRadius: 4, boxShadow: "0 8px 24px rgba(0,0,0,0.1)", overflow: "hidden" }}>
      {registed ? (
        // 已注册用户显示原逻辑
        <Box>
          {userInfo && (
            <>
              <DialogTitle sx={{ fontWeight: 600, textAlign: "center", fontSize: "1.3rem", letterSpacing: 0.5, pb: 0 }}>
                用户信息
              </DialogTitle>
              <DialogContent sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}>
                <Tabs
                  value={activeTab}
                  onChange={(e, v) => {
                    handleTabChange(e, v);
                    setForm({ username: "", password: "", confirmPassword: "" });
                    setErrors({});
                  }}
                  variant="fullWidth"
                  sx={{
                    "& .MuiTab-root": { fontWeight: 500, borderRadius: 3, textTransform: "none" },
                    "& .Mui-selected": { bgcolor: "#f0f0f0" },
                  }}
                >
                  <Tab label="我的账户" />
                  <Tab label="修改密码" />
                </Tabs>

                {/* 我的账户 */}
                {activeTab === 0 && (
                  <Box sx={{ mt: 1, borderRadius: 3, bgcolor: "#fff", boxShadow: "0 4px 12px rgba(0,0,0,0.06)", p: 2.5 }}>
                    <Stack spacing={2}>
                      <Stack direction="row" alignItems="center" spacing={2}>
                        <Box sx={{ width: 56, height: 56, borderRadius: "50%", bgcolor: "#f5f5f7", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "1.2rem", fontWeight: 600, color: "#555" }}>
                          {tuser.user.first_name?.[0]}
                        </Box>
                        <Box>
                          <Typography variant="subtitle1" fontWeight={600}>
                            {tuser.user.first_name} {tuser.user.last_name}
                          </Typography>
                          <Typography variant="body2" color="text.secondary">ID: {tuser.user.id}</Typography>
                        </Box>
                      </Stack>

                      <Stack spacing={1.2} divider={<Box sx={{ borderBottom: "1px solid #eee", my: 0.5 }} />}>
                        <Typography variant="body2" color="text.secondary">
                          用户名：<strong>{userInfo.username}</strong>
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          原创认证：{userInfo.iscouple === 0 ? "否" : "是"}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          今日下载：{userInfo.download} 次
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          银币余额：{userInfo.silver} 枚
                        </Typography>
                        {vipInfo && (
                          <>
                            <Typography variant="body2" sx={{ color: vipInfo.ok ? "#007aff" : "text.secondary", fontWeight: vipInfo.ok ? 600 : 400 }}>
                              身份：{vipInfo.ok ? "VIP用户" : "普通用户"}
                            </Typography>
                            {vipInfo.ok && <Typography variant="body2" color="text.secondary">会员期限：{vipInfo.expire}</Typography>}
                          </>
                        )}
                      </Stack>
                    </Stack>
                  </Box>
                )}

                

                {/* 修改密码 */}
                {activeTab === 1 && (
                  <Stack spacing={2}>
                    <TextField margin="dense" label={errors.password || "新密码"} error={!!errors.password} type="password" fullWidth value={form.password} onChange={handleChange("password")} />
                    <TextField margin="dense" label={errors.confirmPassword || "确认新密码"} error={!!errors.confirmPassword} type="password" fullWidth value={form.confirmPassword} onChange={handleChange("confirmPassword")} />
                  </Stack>
                )}
              </DialogContent>

              <DialogActions sx={{ p: 2, display: "flex", justifyContent: "space-between" }}>
                <Button onClick={onClose} sx={{ textTransform: "none", borderRadius: 3 }}>取消</Button>
                {activeTab === 1 && <Button variant="contained" onClick={handleLogin} sx={{ borderRadius: 3 }}>登录</Button>}
                {activeTab === 2 && <Button variant="contained" onClick={handleChangePass} sx={{ borderRadius: 3 }}>确认修改</Button>}
              </DialogActions>
            </>
          )}
        </Box>
      ) : (
        // 未注册用户增加第一个 Tab 显示 tuser.user 信息
        <Box>
          <DialogTitle sx={{ fontWeight: 600, textAlign: "center", fontSize: "1.3rem", letterSpacing: 0.5 }}>绑定账号密码</DialogTitle>
          <DialogContent sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}>
            <Tabs
              value={activeTab}
              onChange={(e, v) => {
                handleTabChange(e, v);
                setForm({ username: "", password: "", confirmPassword: "" });
                setErrors({});
              }}
              variant="fullWidth"
              sx={{
                "& .MuiTab-root": { fontWeight: 500, borderRadius: 3, textTransform: "none" },
                "& .Mui-selected": { bgcolor: "#f0f0f0" },
              }}
            >
              <Tab label="Telegram" />
              <Tab label="登录" />
              <Tab label="注册绑定" />
            </Tabs>

            {/* Telegram信息 */}
            {activeTab === 0 && (
              <Box sx={{ mt: 1, borderRadius: 3, bgcolor: "#fff", boxShadow: "0 4px 12px rgba(0,0,0,0.06)", p: 2.5 }}>
                <Stack spacing={2}>
  {/* Telegram 用户基本信息 */}
  <Stack direction="row" alignItems="center" spacing={2}>
    <Box
      sx={{
        width: 56,
        height: 56,
        borderRadius: "50%",
        bgcolor: "#f5f5f7",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "1.2rem",
        fontWeight: 600,
        color: "#555",
      }}
    >
      {tuser.user.first_name?.[0]}
    </Box>
    <Box>
      <Typography variant="subtitle1" fontWeight={600}>
        {tuser.user.first_name} {tuser.user.last_name}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        ID: {tuser.user.id}
      </Typography>
    </Box>
  </Stack>

  {/* 已注册用户详细信息 */}
  {userInfo && (
    <Stack
      spacing={1.2}
      divider={<Box sx={{ borderBottom: "1px solid #eee", my: 0.5 }} />}
    >
      <Typography variant="body2" color="text.secondary">
        {userInfo.username ? (
            <strong>用户名：{userInfo.username}</strong>
        ) : (
           <>
  
</>

        )}
        </Typography>

      <Typography variant="body2" color="text.secondary">
        原创认证：{userInfo.iscouple === 0 ? "否" : "是"}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        今日下载：{userInfo.download} 次
      </Typography>
      <Typography variant="body2" color="text.secondary">
        银币余额：{userInfo.silver} 枚
      </Typography>
      {vipInfo && (
        <>
          <Typography
            variant="body2"
            sx={{
              color: vipInfo.ok ? "#007aff" : "text.secondary",
              fontWeight: vipInfo.ok ? 600 : 400,
            }}
          >
            身份：{vipInfo.ok ? "VIP用户" : "普通用户"}
          </Typography>
          {vipInfo.ok && (
            <Typography variant="body2" color="text.secondary">
              会员期限：{vipInfo.expire}
            </Typography>
          )}
        </>
      )}
    </Stack>
  )}

  {/* 用户名不存在时显示登录和注册按钮 */}
  
</Stack>

              </Box>
            )}

            {/* 登录 */}
            {activeTab === 1 && (
              <Stack spacing={2}>
                <TextField margin="dense" label={errors.username || "用户名"} error={!!errors.username} fullWidth value={form.username} onChange={handleChange("username")} />
                <TextField margin="dense" label={errors.password || "密码"} error={!!errors.password} type="password" fullWidth value={form.password} onChange={handleChange("password")} />
              </Stack>
            )}

            {/* 注册绑定 */}
            {activeTab === 2 && (
              <Stack spacing={2}>
                <Typography variant="body2" color="text.secondary">
                  TelegramID: {tuser.user.id}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  为您的电报号注册一个用户名，电报号丢失后，您可以通过用户名和密码找回您的夜未央会员（永久会员请务必绑定）。此账号与网站通用：
                  <Link href="https://www.52ywy.com" target="_blank" rel="noopener noreferrer">www.52ywy.com</Link>
                </Typography>
                <TextField margin="dense" label={errors.username || "用户名"} error={!!errors.username} fullWidth value={form.username} onChange={handleChange("username")} />
                <TextField margin="dense" label={errors.password || "密码"} error={!!errors.password} type="password" fullWidth value={form.password} onChange={handleChange("password")} />
                <TextField margin="dense" label={errors.confirmPassword || "确认密码"} error={!!errors.confirmPassword} type="password" fullWidth value={form.confirmPassword} onChange={handleChange("confirmPassword")} />
              </Stack>
            )}
          </DialogContent>

          <DialogActions sx={{ p: 2 }}>
            <Button onClick={onClose} sx={{ borderRadius: 3 }}>取消</Button>
            {activeTab === 1 ? (
              <Button variant="contained" onClick={handleLogin} sx={{ borderRadius: 3 }}>登录</Button>
            ) : activeTab === 2 ? (
              <Button variant="contained" onClick={handleRegister} sx={{ borderRadius: 3 }}>绑定</Button>
            ) : null}
          </DialogActions>
        </Box>
      )}
    </Box>
  );
};

export default LoginTg;
